export const resetArray = (response) => {
    let list = response.data.data.data;
    let arr = [];
    list.forEach(item => {
        arr.push(item[0])
    })
    return arr;
}